export const renderIssueStatus = (data, issueId) => {
  return data?.filter((issue) => issue?.id === issueId)[0]?.status;
}